import script from "./FELProvider.vue?vue&type=script&setup=true&lang=js"
export * from "./FELProvider.vue?vue&type=script&setup=true&lang=js"

import "./FELProvider.vue?vue&type=style&index=0&id=42ac6060&lang=css"

const __exports__ = script;

export default __exports__